<template>
    <div class="banner banner-bg">
        <div class="banner__inner">
            <img 
                v-if="isDesc"
                :src="'https://lenbuket.ru:8443/' + bannerDesc" 
                class="banner__desc">

            <img 
                v-else
                :src="'https://lenbuket.ru:8443/' + bannerMob" 
                class="banner__mob">
            <!-- <div class="banner__wrapper">
                <img src="../images/banner-logo.svg" class="banner__logo">
                <h1 class="banner__text">Добро пожаловать в Ленбукет — ваш уголок счастья и красоты, где каждый цветок рассказывает свою историю!</h1>
            </div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            isDesc: true,
            bannerDesc: '',
            bannerMob: ''
        }
    },
    methods: {
        getBanners(){
            axios.get('https://lenbuket.ru:8443/api/banner/get').then((res)=>{
                this.bannerDesc = res.data[0].descUrl
                this.bannerMob = res.data[0].mobUrl
            })
        },
    },
    mounted() {
        this.getBanners()
        if (window.innerWidth <= 600) {
            this.isDesc = false
        }
    },
}
</script>

<style scoped>
    /* .banner-bg{
        background: url(../images/banner.png) no-repeat;
        background-size: cover;
        border-radius: 14px;
        overflow: hidden;
    } */
    .banner__inner{
        /* height: calc(100vh - 93px); */
        display: flex;
        height: 100vh;
        max-height: 600px;
        border-radius: 50px;
        overflow: hidden;
    }
    .banner__desc{
        width: 100%;
    }
    .banner__wrapper{
        display: flex;
        height: 100%;
        align-items: center;
    }
    .banner__logo{
        margin-right: 20px;
    }
    .banner__text{
        font-size: 36px;
        font-family: 'Romul';
        color: #fff;
        font-weight: 400;
    }
    @media (max-width: 768px){
        .banner__inner{
            height: calc(100vh - 63px);
        }
        .banner__wrapper{
            flex-direction: column;
            justify-content: center;
        }
        .banner__logo{
            margin-bottom: 50px;
        }
        .banner__text{
            font-size: 24px;
        }
    }
    @media (max-width: 600px){
        .banner__inner{
            height: auto;
            max-height: none;
        }
        .banner-bg{
            background-position: 40% 10%;
        }
        .banner__wrapper{
            align-items: flex-start;
        }
        .banner__logo{
            max-width: 210px;
        }
        .banner__text{
            max-width: 301px;
        }
        .banner__mob{
            width: 100%;
        }
        .banner__inner{
            border-radius: 0;
        }
    }
</style>